import { StyledIconOracle } from './IconOracle.styled';

const IconOracle = () => {
  return <StyledIconOracle />;
};

export default IconOracle;
